import React, { useState, useEffect, useContext } from 'react';
import { AlumnosContext } from '../../context/alumnos/AlumnosContext';
import styled from '@emotion/styled';

const CardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    padding: 10px;
    width: 100%;
    margin-top: 20px;
`;

const Card = styled.div`
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 10px;
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #eee;
    transition: transform 0.2s;

    &:hover {
        transform: translateY(-2px);
    }

    @media (max-width: 576px) {
        width: 100%;
        max-width: 300px;
    }
`;

const MonthTitle = styled.h3`
    font-size: 0.95rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    text-transform: uppercase;
`;

const InputGroup = styled.div`
    width: 100%;
    margin-bottom: 8px;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-size: 0.9rem;

    &:focus {
        outline: none;
        border-color: #28a745;
    }
`;

const SaveButton = styled.button`
    width: 100%;
    padding: 6px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #218838;
    }
`;

export default function FichaCards({ alumno, añoSeleccionado }) {
    const { handlePagos } = useContext(AlumnosContext);
    const [montos, setMontos] = useState({});

    const meses = [
        'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
        'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
    ];

    useEffect(() => {
        const montosIniciales = {};
        if (alumno && alumno.pagos) {
            const pagosFiltrados = alumno.pagos.filter(pago => {
                if (pago.mes && pago.año) return pago.año === añoSeleccionado;
                if (pago.mesPago2025 && añoSeleccionado === 2025) return true;
                if (pago.mesPago) {
                    if (pago.fecha) {
                        const year = parseInt(pago.fecha.split('/')[2]);
                        return year === añoSeleccionado;
                    }
                    return añoSeleccionado === 2024;
                }
                return false;
            });

            pagosFiltrados.forEach(pago => {
                const mes = pago.mes || pago.mesPago2025 || pago.mesPago;
                if (mes) montosIniciales[mes] = pago.monto;
            });
        }
        setMontos(montosIniciales);
    }, [alumno, añoSeleccionado]);

    const handleMontoChange = (mes, valor) => {
        setMontos(prev => ({ ...prev, [mes]: valor }));
    };

    return (
        <CardsContainer>
            {meses.map(mes => (
                <Card key={mes}>
                    <MonthTitle>{mes}</MonthTitle>
                    <InputGroup>
                        <StyledInput
                            type="text"
                            value={montos[mes] || ''}
                            onChange={(e) => handleMontoChange(mes, e.target.value)}
                            placeholder="$ 0.00"
                        />
                    </InputGroup>
                    <SaveButton onClick={() => handlePagos(alumno.id, montos[mes], mes, añoSeleccionado)}>
                        GUARDAR
                    </SaveButton>
                </Card>
            ))}
        </CardsContainer>
    );
}
